"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const graphql_1 = require("../../graphql");
const react_hooks_1 = require("@apollo/react-hooks");
const use_react_router_1 = tslib_1.__importDefault(require("use-react-router"));
exports.useCreateEmailServerSide = ({ templateVersion, openOnCreate, name, }) => {
    var _a;
    const { history: { push }, } = use_react_router_1.default();
    const [mutate, mutationResult] = react_hooks_1.useMutation(graphql_1.createEmailServerSide, {
        onCompleted: ({ createEmailServerSide }) => {
            if (!createEmailServerSide || !createEmailServerSide.id) {
                alert('No email created. Please try again or contact support.');
            }
            if (openOnCreate) {
                push(`/emails/${createEmailServerSide.emailNumber}`);
            }
        },
        variables: {
            data: {
                emailTemplateVersionId: (_a = templateVersion) === null || _a === void 0 ? void 0 : _a.id,
                name,
            },
        },
    });
    return { mutate, mutationResult };
};
//# sourceMappingURL=useCreateEmailServerSide.js.map